import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[form-row]',
    standalone: false
})
export class FormRowDirective {
  @Input()
  visible = true;

  constructor(public templateRef: TemplateRef<any>) {}
}
